import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import about_img from "../Assets/about.jpg";

const About = () => {
  const navigate = useNavigate();
  const backHome = () => {
    navigate("/");
  };

  return (
    <div className="bg-[#111] text-white min-h-screen min-w-screen">
      <div className="absolute right-14 top-7 max-md:right-6 max-md:top-4">
        <button
          onClick={backHome}
          className="after:border-2 after:border-[#009e66] after:w-4/5 after:h-4/5 after:animate-ping after:ease-out after:absolute after:rounded-full after:right-1 after:top-1"
        >
          <CloseIcon sx={{ fontSize: "38px", color: "#009e66" }} />
        </button>
      </div>

      <div className="flex justify-center items-center flex-col h-full">
        <div className="w-full text-center flex flex-col gap-4 mt-16 mb-2">
          <p className="text-thin text-[#9f9f9f]">Get to Know About Me</p>
          <h1 className="text-5xl">About</h1>
        </div>

        <div className="space-y-2 py-2 mx-auto lg:w-3/4 max-md:w-full flex flex-col lg:flex-row text-center lg:text-left">
          <img
            src={about_img}
            className="w-1/3 max-md:w-1/2 border-2 rounded-full mx-auto"
            alt="Md Imam Hosen"
          />

          <div className="lg:flex lg:flex-col mt-4 lg:mt-0 lg:justify-center">
            <div className="pl-2 lg:w-11/12 mx-auto">
              <h1 className="text-[#009e66] text-2xl px-2">Who am I?</h1>

              <h1 className="text-3xl font-bold px-2 mt-1">
                Hi, I'm Md Imam Hosen — Full Stack Developer & Problem Solver
              </h1>

              <div className="about-section text-[#9f9f9f] text-sm md:text-base p-2 space-y-2">
                <p>
                  I am Md. Imam Hosen, a dedicated and passionate full stack web developer currently pursuing my B.Sc in Computer Science and Engineering at the University of Barisal. I love building impactful web applications and constantly challenge myself through real-world projects and competitive programming.
                </p>
                <p>
                  My expertise spans both frontend and backend development. I’m proficient in <strong>React.js</strong>, <strong>Next.js</strong>, <strong>Tailwind CSS</strong>, <strong>Redux</strong>, and <strong>TypeScript</strong> on the frontend. On the backend, I work with <strong>Node.js</strong>, <strong>Express.js</strong>, and databases like <strong>MongoDB</strong>, <strong>PostgreSQL</strong>, and <strong>MySQL</strong>, using <strong>Prisma ORM</strong> and <strong>Mongoose</strong> for data modeling.
                </p>
                <p>
                  I'm also exploring systems programming and microservices using <strong>Golang (Go)</strong>. My problem-solving mindset is reflected through platforms like <strong>Codeforces</strong> and <strong>LeetCode</strong>. I enjoy contributing to projects like <strong>KrishiBondhu</strong>, <strong>ArtVista</strong>, and <strong>LifeFlow</strong>, aiming to create user-centric and scalable solutions.
                </p>
              </div>

              <hr className="text-[#9f9f9f] mb-2 w-11/12 mx-auto my-2" />
            </div>

            <div className="flex w-11/12 mx-auto flex-col">
              <div className="flex flex-col md:flex-row md:justify-between py-2">
                <div className="flex gap-2">
                  <span>Name:</span>
                  <p className="text-[#9f9f9f]">Md. Imam Hosen</p>
                </div>
                <div className="flex gap-2">
                  <span>Email:</span>
                  <p className="text-[#009e66] hover:text-[#346b57]">
                    <a
                      href="mailto:mdimam.cse9.bu@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      mdimam.cse9.bu@gmail.com
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row md:justify-between py-2">
                <div className="flex gap-2">
                  <span>Age:</span>
                  <p className="text-[#9f9f9f]">23</p>
                </div>
                <div className="flex gap-2">
                  <span>Live:</span>
                  <p className="text-[#9f9f9f]">Barishal, Bangladesh</p>
                </div>
              </div>

              <div className="mt-2 ml-4">
                <a
                  href="./Resume of Md Imam Hosen Software Developer.pdf"
                  download="Resume of Md Imam Hosen"
                  className="bg-[#009e66] hover:bg-[#0e522b] text-white font-bold py-2 px-4 rounded-full inline-block"
                >
                  Download Resume
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
